export default "__VITE_ASSET__BerOUAxR__"